import type { AchievementRewards } from '@/lib/campaign-gamification'
import styles from './AchievementRewardsEditor.module.css'

export function AchievementRewardsEditor({
  id,
  value,
  disabled,
  onChange,
  annual = false,
}: {
  id: string
  value: AchievementRewards
  disabled: boolean
  onChange: (value: AchievementRewards) => void
  annual?: boolean
}) {
  const options = [
    {
      key: 'coupon_percent',
      label: 'Cupom de desconto',
      unit: 'Desconto (%)',
      max: 100,
      step: 0.01,
      initial: 10,
    },
    {
      key: 'lucky_numbers',
      label: 'Números extras',
      unit: 'Quantidade de números',
      max: 1000,
      step: 1,
      initial: 1,
    },
    {
      key: 'roulette_spins',
      label: 'Giros na roleta',
      unit: 'Quantidade de giros',
      max: 100,
      step: 1,
      initial: 1,
    },
  ] as const
  return (
    <fieldset className={styles.rewards} disabled={disabled}>
      <legend>Extras ao conquistar</legend>
      <p>
        Combine os prêmios que desejar ou deixe todos desmarcados. Cada cliente recebe uma
        única vez por selo e campanha{annual ? ' em cada ano' : ''}.
      </p>
      <div className={styles.options}>
        {options.map(({ key, label, unit, max, step, initial }) => {
          const enabled = value[key] !== null && Number(value[key]) > 0
          return (
            <div key={key} className={styles.option} data-enabled={enabled}>
              <label className={styles.check}>
                <input
                  type="checkbox"
                  checked={enabled}
                  onChange={(event) =>
                    onChange({
                      ...value,
                      [key]: event.target.checked
                        ? initial
                        : key === 'coupon_percent'
                          ? null
                          : 0,
                    })
                  }
                />
                {label}
              </label>
              {enabled && (
                <label className={styles.amount} htmlFor={`${id}-${key}`}>
                  {unit}
                  <input
                    id={`${id}-${key}`}
                    type="number"
                    min={step}
                    max={max}
                    step={step}
                    value={value[key] ?? ''}
                    onChange={(event) =>
                      onChange({
                        ...value,
                        [key]:
                          event.target.value === ''
                            ? initial
                            : Number(event.target.value),
                      })
                    }
                  />
                </label>
              )}
            </div>
          )
        })}
        <div className={styles.option}>
          <label className={styles.check}>
            <input type="checkbox" disabled checked={false} readOnly />
            Raspadinha extra
          </label>
          <small>Em breve</small>
        </div>
      </div>
      <p>
        Cupons ficam disponíveis para a próxima compra. Números ficam pendentes para
        resgate. Giros usam a roleta da campanha e exigem compartilhamento.
      </p>
      <small>
        Alterações valem para novas entregas. Reativar o selo não repete prêmios já
        concedidos.
      </small>
    </fieldset>
  )
}
